import _ from 'lodash'
import { isProjectContainer } from '../constants/toUnits'
import { rulesHashMap } from './widgets'

export const getRules = (key, currentPageUID, projectID, retState) => {
  const ret = _.get(rulesHashMap, key)
  if (ret) {
    if (!currentPageUID || String(key).indexOf(':') === -1) {
      let result = _.filter(ret, (k) => {
        if (k && _.isArray(k)) {
          let isFound = false
          if (retState) {
            if (isProjectContainer(retState, k[0])) {
              return true
            }
          }
          _.each(k, function (k2) {
            if (
              !currentPageUID ||
              String(k2).indexOf(`${projectID}:`) > -1 ||
              String(k2).indexOf(`${currentPageUID}:`) > -1
            ) {
              isFound = true
            }
          })
          return isFound
        } else {
          if (
            !currentPageUID ||
            String(k).indexOf(`${projectID}:`) > -1 ||
            String(k).indexOf(`${currentPageUID}:`) > -1
          ) {
            return true
          }
        }
      })
      return result
    } else if (
      currentPageUID &&
      projectID &&
      (String(key).indexOf(currentPageUID) > -1 || String(key).indexOf(projectID) > -1)
    ) {
      return ret
    } else {
      if (String(key).indexOf(':') > -1) {
        if (retState) {
          let k = String(key).split(':')
          if (isProjectContainer(retState, k[0])) {
            return ret
          }
        }
      } else {
        return null
      }
    }
  } else {
    let result = []
    _.each(rulesHashMap, (v, k) => {
      if (k.endsWith(key) || k.indexOf(key + ':') !== -1) {
        result.push(...v)
      }
    })
    return result
  }
}
